import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import "antd/dist/reset.css";
import "./index.css";
import { App as AppAnt, ConfigProvider } from "antd";
import { lightMode } from "../theme.config.ts";
import App from "./App.tsx";
import dayjs from "dayjs";
import "dayjs/locale/fa";
import faIR from "antd/locale/fa_IR";

dayjs.locale("fa");

createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <ConfigProvider
      locale={faIR}
      form={{
        scrollToFirstError: {
          behavior: "smooth",
          block: "center",
          scrollMode: "if-needed",
        },
      }}
      theme={lightMode}
    >
      <StrictMode>
        <AppAnt>
          <App />
        </AppAnt>
      </StrictMode>
    </ConfigProvider>
  </BrowserRouter>,
);
